export const API_URL = 'https://api.kinomap.dev/v4';
export const APP_TOKEN =
  '2EZOqOTGgOhZLsyWXABp5NBnWri7tLDEfWVmM5u1CW8QgXcNt1ZsAvThlB6MR4sNoMCQA6tbqX3ShGyRqJ6Tt5rVpvvvLQPz5eV5hOhdurVfOWd40jo6fUvy';
export const OAUTH_BASE_URL = 'https://login.kinomap.dev';

export const environment = {
  oauth: {
    url: OAUTH_BASE_URL,
  },
  api: {
    client: {
      me: API_URL + '/me?appToken=' + APP_TOKEN,
    },
    contest: {
      infos: API_URL + '/contest/informations/:username/:hashid',
      user: API_URL + '/contest/user/:username/:hashid',
      deleteActivity: API_URL + '/contest/delete/:id?appToken=' + APP_TOKEN,
      export: API_URL + '/contest/export/:username/:hashid?appToken=' + APP_TOKEN,
      reset: API_URL + '/contest/reset/:username/:hashid?appToken=' + APP_TOKEN,
    },

    goal: {
      data: API_URL + '/contest/goal/:username?appToken=' + APP_TOKEN,
      export: API_URL + '/contest/goal/export/:username?appToken=' + APP_TOKEN,
      reset: API_URL + '/contest/goal/reset/:username?appToken=' + APP_TOKEN,
    }
  },
  contestInfo: {
    userPerPage: 50,
  },
};
